/**
 * RESPONSIBILITY: which sections make up the Ministries index, and in what order.
 *
 * Two bands, two pencils: the page's own words, and the one ministries list. The list
 * band's pencil is where a ministry is added, removed or reordered.
 *
 * AND EACH CARD CARRIES ITS OWN, for whoever may edit: it opens the list narrowed to that
 * one ministry - see `focus` - because somebody fixing one description does not want eight
 * ministries to find it among. A visitor is given the plain card with nothing around it,
 * so what they see is exactly what it was before the pencils.
 */
import { idOf, rowById } from '@framework/core';
import { SectionName } from '@app/sections';
import { SectionUpdate } from '../cms';
import { Crumbs, PageHead, Ministries, MinistryCard, isShown } from '../site';

export function MinistriesPage() {
  return (
    <main>
      <Crumbs trail={[{ label: 'Ministries' }]} />

      <SectionUpdate name={SectionName.MinistriesHero}>
        {(c) => <PageHead eyebrow={c.eyebrow} heading={c.heading} intro={c.intro} />}
      </SectionUpdate>

      {/* `canEdit` widens the list rather than replacing it, exactly as the events page
          does: an editor sees what a visitor sees plus the ones switched off, marked. */}
      <SectionUpdate name={SectionName.Ministries}>
        {(c, edit) => (
          <Ministries
            ministries={(c.ministries ?? []).filter((m) => edit.canEdit || isShown(m))}
            card={edit.canEdit ? (m) => (
              <SectionUpdate name={SectionName.Ministries} focus={{ field: 'ministries', rowId: idOf(m) }}>
                {(inner) => <MinistryCard m={rowById(inner.ministries ?? [], idOf(m)) ?? m} />}
              </SectionUpdate>
            ) : undefined}
          />
        )}
      </SectionUpdate>
    </main>
  );
}
